/* Note: Created a base icon component because we're currently using a couple different icon libraries
 * and this will allow us to standardize the icons used across the application.
 */

import { joinClasses } from '@/utils/styling';
import { Calendar, Clock, File, Tag } from 'react-feather'

export type IconName =
    | 'success'
    | 'warning'
    | 'error'
    | 'info'

    | 'bar-chart-fill'
    | 'calendar'
    | 'check-circle-fill'
    | 'chevron-down'
    | 'chevron-right'
    | 'chevron-up'
    | 'clock'
    | 'download'
    | 'exclamation-triangle-fill'
    | 'external'
    | 'file'
    | 'file-earmark-fill'
    | 'filter'
    | 'house-fill'
    | 'people-fill'
    | 'person-circle'
    | 'question-circle-fill'
    | 'table'
    | 'tag'
    | 'trash'
    | 'upload';

type IconProps = {
    name?: IconName | undefined;
    className?: string;
}

export default function Icon({
    name,
    className = ''
}: IconProps) {
    switch (name) {
        case 'success':
            return <span className={joinClasses("ca-gov-icon-check-fill", className)} aria-hidden="true"></span>;
        case 'warning':
            return <span className={joinClasses("ca-gov-icon-warning-triangle", className)} aria-hidden="true"></span>;
        case 'error':
            return <span className={joinClasses("ca-gov-icon-warning-diamond", className)} aria-hidden="true"></span>;
        case 'info':
            return <span className={joinClasses("ca-gov-icon-info", className)} aria-hidden="true"></span>;

        case 'calendar':
            return <span className={joinClasses("bi bi-calendar-fill", className)} aria-hidden="true"></span>
        case 'clock':
            return <span className={joinClasses("bi bi-clock-fill", className)} aria-hidden="true"></span>
            // return <Clock style={{ height: "1em", width: "1em", verticalAlign: "-0.125em" }} />
        case 'download':
            // Could replace with Feather or Bootstrap "download" icon (simpler, more general design than file-download)
            // return <span className={joinClasses("ca-gov-icon-file-download", className)} aria-hidden="true"></span>;
            // return <span className={joinClasses("bi bi-file-earmark-arrow-down-fill", className)} aria-hidden="true"></span>
            return <span className={joinClasses("bi bi-download", className)} aria-hidden="true"></span>
        case 'external':
            return <span className={joinClasses("bi bi-box-arrow-up-right", className)} aria-hidden="true"></span>
        case 'file':
            return <span className={joinClasses("bi bi-file-earmark-fill", className)} aria-hidden="true"></span>
        case 'filter':
            return <span className={joinClasses("bi bi-funnel-fill", className)} aria-hidden="true"></span>
        case 'tag':
            return <span className={joinClasses("bi bi-tag-fill", className)} aria-hidden="true"></span>
        case 'trash':
            return <span className={joinClasses("ca-gov-icon-delete", className)} aria-hidden="true"></span>;
        default:
            return <span className={joinClasses(`bi bi-${name}`, className)} aria-hidden="true"></span>
    }
}